/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BlogEntryId
 */
export interface BlogEntryId {
    /**
     * 
     * @type {string}
     * @memberof BlogEntryId
     */
    id?: string;
}

/**
 * Check if a given object implements the BlogEntryId interface.
 */
export function instanceOfBlogEntryId(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function BlogEntryIdFromJSON(json: any): BlogEntryId {
    return BlogEntryIdFromJSONTyped(json, false);
}

export function BlogEntryIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): BlogEntryId {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
    };
}

export function BlogEntryIdToJSON(value?: BlogEntryId | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}

